import * as stateNames from 'constants/states'
import * as actionTypes from 'constants/actionTypes'
import createThunkReducer from 'utils/createThunkReducer'

export default {
  [stateNames.CLINICS_CREATE]: createThunkReducer(actionTypes.CLINICS_CREATE),
  [stateNames.CLINICS_LIST]: createThunkReducer(actionTypes.CLINICS_LIST),
}
